(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["deal-timer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('deal-timer')) {
    const dealTimers = new Set();
    let dealTimerTick = null;
    const unit = (n, word) => n + ' ' + word + (n === 1 ? '' : 's');

    const updateDealTimer = (el) => {
      const left = Math.floor(el.endTime - Date.now() / 1000);
      if (left <= 0) {
        el.hidden = true;
        dealTimers.delete(el);
        return;
      }
      const days = Math.floor(left / 86400);
      const hours = Math.floor((left % 86400) / 3600);
      const minutes = Math.floor((left % 3600) / 60);

      const parts = [];
      if (days > 0) parts.push(unit(days, 'day'));
      if (days > 0 || hours > 0) parts.push(unit(hours, 'hour'));
      if (left < 60) {
        parts.push('under 1 minute');
      } else {
        parts.push(unit(minutes, 'minute'));
      }

      const text = parts.join(' ');
      if (el.timeEl.textContent !== text) el.timeEl.textContent = text;
    };

    class DealTimer extends HTMLElement {
      connectedCallback() {
        this.endTime = parseInt(this.dataset.end, 10);
        this.timeEl = this.querySelector('.deal-timer__time');
        if (!this.endTime || !this.timeEl) return;

        dealTimers.add(this);
        updateDealTimer(this);

        if (!dealTimerTick) {
          dealTimerTick = setInterval(() => dealTimers.forEach(updateDealTimer), 1000);
        }
      }

      disconnectedCallback() {
        dealTimers.delete(this);
      }
    }

    customElements.define('deal-timer', DealTimer);
  }
  } catch(e) { console.error(e); }
})();

})();
